import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { generateRoutePath } from 'epic-ue-locale-mode';

export default class Tile extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
        url: PropTypes.string,
        description: PropTypes.string,
        credits: PropTypes.string,
        image: PropTypes.string,
        colLg: PropTypes.string
    };

    render() {
        const {title, description, image, credits, colLg, url} = this.props;

        const imgStyle = {
            background: `url(${image}) center center no-repeat`,
            backgroundSize: 'cover',
            height: '100%',
            width: '100%'
        };

        let titleContent = (
            <div
                className={`careers-discipline col-xs-12 col-sm-6 col-md-6 ${colLg || 'col-lg-3'}`}>
                <div className="careers-discipline-img-wrapper">
                    {image !== undefined ? (
                        <div className="image-bg" title={title} style={imgStyle} />
                    ) : (
                        ''
                    )}
                    <span className="credits">{credits}</span>
                </div>
                <div className="careers-discipline-desc">
                    <h3>{title}</h3>
                    <div dangerouslySetInnerHTML={{__html: description}} />
                </div>
            </div>
        );

        if (url) {
            titleContent = (
                <Link
                    to={generateRoutePath(url)}
                    className={`careers-discipline col-xs-12 col-sm-6 col-md-6 ${
                        colLg || 'col-lg-3'
                    }`}>
                    <div className="careers-discipline-img-wrapper">
                        {image !== undefined ? (
                            <div className="image-bg" title={title} style={imgStyle} />
                        ) : (
                            ''
                        )}
                        <span className="credits">{credits}</span>
                    </div>
                    <div className="careers-discipline-desc">
                        <h3>{title}</h3>
                        <div dangerouslySetInnerHTML={{__html: description}} />
                    </div>
                </Link>
            );
        }

        return <div>{titleContent}</div>;
    }
}
